export default "/_next/static/chunks/fonts/Entypo-a10f41248184205e8db8865abdf66332.ttf";